'use client'

import { useState } from 'react'

export function ContatoForm() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' })
  const [sending, setSending] = useState(false)
  const [honeypot, setHoneypot] = useState('')
  const [result, setResult] = useState<{ ok: boolean; ticket_number?: number; error?: string } | null>(null)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    // Honeypot anti-bot
    if (honeypot) {
      setResult({ ok: true, ticket_number: 9999 })
      return
    }

    setSending(true)
    setResult(null)

    const res = await fetch('/api/contato', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form),
    })
    const data = await res.json()

    if (res.ok) {
      setResult({ ok: true, ticket_number: data.ticket_number })
      setForm({ name: '', email: '', phone: '', message: '' })
    } else {
      setResult({ ok: false, error: data.error || 'Erro ao enviar. Tente novamente.' })
    }
    setSending(false)
  }

  if (result?.ok) {
    return (
      <div className="bg-white border border-gray-200 rounded-2xl p-6 sm:p-8 text-center">
        <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h2 className="text-lg font-semibold text-gray-900 mb-2">Mensagem enviada!</h2>
        <p className="text-sm text-gray-500 mb-1">
          Seu chamado foi registrado com o número:
        </p>
        <p className="text-2xl font-bold text-gray-900 mb-4">
          #{String(result.ticket_number).padStart(4, '0')}
        </p>
        <p className="text-xs text-gray-400">
          Retornaremos para o email informado o mais breve possível.
        </p>
        <button
          onClick={() => setResult(null)}
          className="mt-6 text-sm text-gray-500 hover:text-gray-900 transition-colors"
        >
          Enviar outra mensagem
        </button>
      </div>
    )
  }

  return (
    <form onSubmit={handleSubmit} className="bg-white border border-gray-200 rounded-2xl p-4 sm:p-6 space-y-4">
      <div>
        <label className="block text-xs text-gray-500 mb-1">Nome completo *</label>
        <input
          type="text"
          required
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
          className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-gray-400"
          placeholder="Seu nome"
        />
      </div>

      <div>
        <label className="block text-xs text-gray-500 mb-1">Email *</label>
        <input
          type="email"
          required
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
          className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-gray-400"
          placeholder="seu@email.com"
        />
      </div>

      <div>
        <label className="block text-xs text-gray-500 mb-1">Telefone</label>
        <input
          type="text"
          value={form.phone}
          onChange={(e) => setForm({ ...form, phone: e.target.value })}
          className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-gray-400"
          placeholder="(11) 99999-9999"
        />
      </div>

      <div>
        <label className="block text-xs text-gray-500 mb-1">Mensagem *</label>
        <textarea
          required
          rows={5}
          value={form.message}
          onChange={(e) => setForm({ ...form, message: e.target.value })}
          className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-gray-400 resize-y"
          placeholder="Descreva como podemos ajudar..."
        />
      </div>

      {result?.error && (
        <p className="text-xs text-red-600 bg-red-50 px-3 py-2 rounded-lg">{result.error}</p>
      )}

      {/* Honeypot anti-bot */}
      <input
        type="text"
        value={honeypot}
        onChange={(e) => setHoneypot(e.target.value)}
        autoComplete="off"
        tabIndex={-1}
        aria-hidden="true"
        style={{ position: 'absolute', left: '-9999px', opacity: 0 }}
      />

      <button
        type="submit"
        disabled={sending}
        className="w-full bg-gray-900 text-white py-2.5 rounded-lg text-sm font-semibold hover:bg-gray-700 transition-colors disabled:opacity-50"
      >
        {sending ? 'Enviando...' : 'Enviar mensagem'}
      </button>
    </form>
  )
}
